export default __webpack_public_path__ + "static/banner-19eea7e0d58708fb44e21273f1c4027f.svg";